import { render, staticRenderFns } from "./CredenciamentoFornecedorResultadoVazio.vue?vue&type=template&id=67926167&scoped=true"
import script from "./CredenciamentoFornecedorResultadoVazio.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorResultadoVazio.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoFornecedorResultadoVazio.vue?vue&type=style&index=0&id=67926167&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67926167",
  null
  
)

export default component.exports